import {config} from "@/config/config.ts";
import {StatusBar, Style} from "@capacitor/status-bar";
import {type ClassValue, clsx} from "clsx"
import {twMerge} from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}

export function toggleDark() {
    localStorage.theme = (localStorage.theme === 'dark' ? 'light' : 'dark');
    applyCurrentTheme();
}

export function applyCurrentTheme() {
    try {
        document?.querySelector('html')?.classList.toggle('dark', localStorage.theme === 'dark');
        document?.querySelector('html')?.classList.toggle('light', localStorage.theme !== 'dark');

        if (config.isCordova) {
            StatusBar.setStyle({style: (localStorage.theme === 'dark' ? Style.Dark : Style.Light)});
        }
    } catch (reason) {
        alert(`Error: ${reason}`);
    }
}

export function currencySymbol(code: string) {
    const currencySymbols = {
        USD: '$',
        EUR: '€',
        GBP: '£',
        AED: 'AED ',
    }
    return currencySymbols[code]
}
